import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './BackButton.css';
import { isCapacitor } from '../../utils/platform';

function BackButton({ to = '/home', ...props }) {
  const navigate = useNavigate();

  const handleClick = () => {
    const hasHistory = typeof window !== 'undefined' && window.history && window.history.length > 1;
    if (hasHistory) {
      navigate(-1);
    } else {
      navigate(to, { replace: true });
    }
  };

  return (
    <button
      className={`back-button-sticky ${isCapacitor ? 'back-button-capacitor' : ''}`}
      onClick={handleClick}
      aria-label="Retour à l'accueil"
      {...props}
    >
      <FaArrowLeft className="back-button-icon" />
    </button>
  );
}

export default BackButton;